export const getSessionStorage =  key => {
    if (sessionStorage.getItem(`oidc.user:${process.env.REACT_APP_BASE_URL_OIDC}:crew_idp_client`)) {
        if (key) return JSON.parse(sessionStorage.getItem(`oidc.user:${process.env.REACT_APP_BASE_URL_OIDC}:crew_idp_client`))[key]
        else return JSON.parse(sessionStorage.getItem(`oidc.user:${process.env.REACT_APP_BASE_URL_OIDC}:crew_idp_client`))
    }
}
